import type { ManagedApiCaching, ManagedApiCachingStrategy } from '@ms/yammer-data/dist/api/types';
import type { HostClientType } from '@ms/yammer-web-support/dist/metaOsHub';
import { isSafeToCachePersonalData } from '@ms/yammer-web-support/dist/metaOsHub';

const daysToSeconds = (days: number) => days * 24 * 60 * 60;
const minutesToSeconds = (minutes: number) => minutes * 60;

const currentUserCacheTimeInSeconds = daysToSeconds(7);
const featureAccessSettingsCacheTimeInSeconds = daysToSeconds(7);
const networkTopicSettingsCacheTimeInSeconds = daysToSeconds(7);
const ecsCacheTimeInSeconds = daysToSeconds(7);

type GetSafeCaching = (
  strategy: ManagedApiCachingStrategy,
  hostClientType?: HostClientType
) => ManagedApiCaching | undefined;

export const currentUserCacheTTLInSeconds = minutesToSeconds(5);
export const featureAccessSettingsCacheTTLInSeconds = minutesToSeconds(5);
export const networkTopicSettingsCacheTTLInSeconds = minutesToSeconds(5);

type GetFeatureFlightingApiCaching = (isBackgroundLoad: boolean) => ManagedApiCaching;
export const getFeatureFlightingApiCaching: GetFeatureFlightingApiCaching = (isBackgroundLoad) => ({
  strategy: isBackgroundLoad ? 'FetchAndWriteCache' : 'ReadCacheAndRevalidate',
  ttlInSeconds: ecsCacheTimeInSeconds,
});

export const getCurrentUserApiCaching: GetSafeCaching = (strategy, hostClientType) => {
  const isSafeToCache = isSafeToCachePersonalData(hostClientType);

  return isSafeToCache ? { strategy, ttlInSeconds: currentUserCacheTimeInSeconds } : undefined;
};

export const getFeatureAccessSettingsApiCaching: GetSafeCaching = (strategy, hostClientType) => {
  const isSafeToCache = isSafeToCachePersonalData(hostClientType);

  return isSafeToCache ? { strategy, ttlInSeconds: featureAccessSettingsCacheTimeInSeconds } : undefined;
};

export const getNetworkTopicSettingsApiCaching: GetSafeCaching = (strategy, hostClientType) => {
  const isSafeToCache = isSafeToCachePersonalData(hostClientType);

  return isSafeToCache ? { strategy, ttlInSeconds: networkTopicSettingsCacheTimeInSeconds } : undefined;
};
